<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>
                <translate>Lieferverzögerung bearbeiten</translate>
            </modal-header>
            <modal-content>
                <form-group>
                    <form-input id="new_delivery_date" name="new_delivery_date" label="Neuer Liefertermin (Produzent)" v-model="form.new_delivery_date"
                                :error="form.errors.new_delivery_date" disabled="true"/>

                    <form-datepicker id="corrected_delivery_date" name="corrected_delivery_date" label="Korrigierter Liefertermin"
                                     v-model:date="form.corrected_delivery_date" :error="form.errors.corrected_delivery_date"/>
                </form-group>


                <form-text id="comment" name="comment" label="Kommentar" v-model="form.comment"
                            :error="form.errors.comment"/>

            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Melden</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import {useForm} from '@inertiajs/vue3';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import FormText from '@partfactory/Shared/Form/FormText';

export default {
    name: 'ProducerLateDeliveryModal',
    components: {
        FormText,
        FormGroup, ModalActions, ModalContent, ModalHeader, FormButton, FormInput, FormDatepicker, Modal},
    emit: ['closeDialog'],
    props: {
        askForQuote: Object,
        producerLateDelivery: Object,
    },
    data() {
        const form = useForm({
            new_delivery_date: this.$date(this.producerLateDelivery.new_delivery_date),
            corrected_delivery_date: this.producerLateDelivery?.corrected_delivery_date ? this.producerLateDelivery?.corrected_delivery_date : null,
            comment: this.producerLateDelivery?.comment ? this.producerLateDelivery?.comment : null,
        });

        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.delivery.producer-late-delivery', {'askForQuote': this.askForQuote.id, 'producerLateDelivery': this.producerLateDelivery.id}), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        },
    }
};
</script>
